import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { AgmCoreModule } from '@agm/core';
import { NgSelectModule } from '@ng-select/ng-select';
// import { ChartsModule } from 'ng2-charts';
import { FileUploadModule } from 'ng2-file-upload';
// import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgChartsModule } from 'ng2-charts';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { NgtreegridModule } from 'ngtreegrid';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HttpClientModule } from '@angular/common/http';
import { NgApexchartsModule } from 'ng-apexcharts';
// import { ToastrModule } from 'ng6-toastr-notifications';
import { ToastrModule } from 'ngx-toastr';
import { SharedModule } from 'src/app/shared/shared.module';
import { NocLayoutRoutingModule } from './noc-layout-routing.module';
import { NocSidebarComponent } from './noc-sidebar/noc-sidebar.component';
import { NocFooterComponent } from './noc-footer/noc-footer.component';
import { RouterModule } from '@angular/router';
import { NocDashboardComponent } from '../noc-dashboard/noc-dashboard.component';
import { NocLayoutComponent } from './noc-layout.component';
import { NocHeaderComponent } from './noc-header/noc-header.component';
import { AdminstrationComponent} from '../adminstration/adminstration.component';
import { DataAssignmentComponent } from '../adminstration/data-assignment/data-assignment.component';
import { RoleComponent } from '../adminstration/role/role.component';
import { UserComponent } from '../adminstration/user/user.component';
import { WorkFlowComponent } from '../adminstration/work-flow/work-flow.component';
import { SettingComponent } from '../setting/setting.component';
import { CodeValueComponent } from '../setting/code-value/code-value.component';
import { FieldComponent } from '../setting/field/field.component';
import { HierachyComponent } from '../setting/hierachy/hierachy.component';
import { NocListComponent } from '../noc-list/noc-list.component';
import { EditorComponent } from 'src/app/md/editor/editor.component'; 

import { AfterDepartmentComponent } from '../after-department/after-department.component';

import { NocViewComponent } from '../noc-view/noc-view.component';

import { NocBillComponent } from '../noc-bill/noc-bill.component';
import {MatCardModule} from '@angular/material/card';
// import { HomeComponent } from '../../operation/home/home.component';
// import {EditorComponent} from '../../operation/editor/editor.component'
import { AccountantComponent } from '../accountant/accountant.component';
import { CartoScreenComponent } from '../carto-screen/carto-screen.component';
// import { CartoScreeComponent } from 'src/app/carto-scree/carto-scree.component';
@NgModule({
  declarations: [
    NocSidebarComponent,
    NocFooterComponent,
    NocLayoutComponent,
    NocDashboardComponent,
    NocHeaderComponent,
    AdminstrationComponent,
    DataAssignmentComponent,
    RoleComponent,
    UserComponent,
    WorkFlowComponent,
    SettingComponent,
    CodeValueComponent,
    FieldComponent,
    HierachyComponent,
    NocListComponent,

    
    AfterDepartmentComponent,
  
    NocViewComponent,
    CartoScreenComponent,

    NocBillComponent,
    AccountantComponent,
    

    // EditorComponent
  ],
  exports: [
    NocSidebarComponent,
    NocFooterComponent,
    NocLayoutComponent,
    NocHeaderComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    CommonModule,

    NgSelectModule,
    NgChartsModule,
    FileUploadModule,
    MatInputModule,
    // NgbModule,
    MatSlideToggleModule,
    FormsModule,
    MatCardModule,
    // NgtreegridModule,
    MatStepperModule,
    MatCheckboxModule,
    MatExpansionModule,
    NgxSpinnerModule,
    HttpClientModule,
    MatSnackBarModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    NgApexchartsModule,
    ReactiveFormsModule,
    MatTabsModule,
    RouterModule,
    NocLayoutRoutingModule
    // ToastrModule.forRoot(),
  ],

})
export class NocLayoutModule { }
